if (typeof String.prototype.supplant !== 'function') {
    String.prototype.supplant = function (o) {
        return this.replace(/{([^{}]*)}/g,
			function (a, b) {
			    var r = o[b];
			    return typeof r === 'string' ?
			        r : a;
			});
    };
}